function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("hxssF", function(module, exports) {
    $parcel$export(module.exports, "RecommendPremiumToStandardModalComponent", ()=>$9125d6c6dde86234$export$e2ad8f867d457fc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $joX8T;
    var $7XluA;
    var $4mO32;
    var $6s1PB;
    var $lpwtK;
    var $dRVix;
    var $k9JTq;
    var $koeKL;
    var $5oBMG;
    var $8y2Jg;
    var $2LVEz;
    const $9125d6c6dde86234$var$RecommendPremiumToStandardModalComponentImpl = ()=>{
        const cloudID = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const RecommendPremiumToStandardModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudIds: [
                    cloudID
                ]
            }), [
            cloudID
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("8y2Jg")).recommendPremiumToStandardModalEntryPoint), RecommendPremiumToStandardModalEntryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraRecommendPremiumToStandard",
            packageName: "jira-recommend-premium-to-standard-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: "unmount",
            runtimeProps: {}
        });
    };
    const $9125d6c6dde86234$export$e2ad8f867d457fc6 = ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type);
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const productEntitlementDetails = (0, (0, parcelRequire("5oBMG")).useProductEntitlementDetails)();
        const productKey = projectType && (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
        const billingSourceSystem = entitlementDetails?.billingSourceSystem;
        const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
        const daysLeft = (0, (0, parcelRequire("dRVix")).getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime) ?? 0;
        const eligibleDaysLeft = daysLeft === 1 || daysLeft === 3 || daysLeft === 5;
        const [reccStdConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('recommend_standard_purchase_in_jira_premium_eot');
        const reccStdExperimentCohort = (0, $5uXOq.useMemo)(()=>reccStdConfig.get('cohort', 'not-enrolled'), [
            reccStdConfig
        ]);
        if (!(0, (0, parcelRequire("2LVEz")).isProjectTypeAndEditionSupported)(appEditions, project?.type) || reccStdExperimentCohort === (0, (0, parcelRequire("joX8T")).NOT_ENROLLED) || billingSourceSystem !== 'CCP' || !eligibleDaysLeft) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9125d6c6dde86234$var$RecommendPremiumToStandardModalComponentImpl, null);
    };
});
parcelRegister("joX8T", function(module, exports) {
    $parcel$export(module.exports, "COHORT", ()=>$a85d1363752adaec$export$3d370c33621572df);
    $parcel$export(module.exports, "NOT_ENROLLED", ()=>$a85d1363752adaec$export$5b7423264d48ab04);
    $parcel$export(module.exports, "CONTROL", ()=>$a85d1363752adaec$export$43f367b3e957f219);
    $parcel$export(module.exports, "VARIATION", ()=>$a85d1363752adaec$export$fa04ad826acc90da);
    var $co1wz;
    const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
    const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
    const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
    const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
    const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
    const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
    const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
    const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
    const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
    const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
        $a85d1363752adaec$export$5b7423264d48ab04,
        $a85d1363752adaec$export$43f367b3e957f219,
        $a85d1363752adaec$export$9ba2bc3b1bdc1519,
        $a85d1363752adaec$export$fa04ad826acc90da,
        $a85d1363752adaec$export$6486974e39493fa6,
        $a85d1363752adaec$export$7d994996134ad562,
        $a85d1363752adaec$export$795e7d69b248dcd0,
        $a85d1363752adaec$export$c9c947c57470b787
    ];
    var $a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);
});
parcelRegister("dRVix", function(module, exports) {
    $parcel$export(module.exports, "useIsJswUsingCcp", ()=>$9ce9420d6adb67d7$export$f8e1c288fefa6e7d);
    $parcel$export(module.exports, "useIsProductUsingCcp", ()=>$9ce9420d6adb67d7$export$b367e04990bbb76d);
    $parcel$export(module.exports, "useLoggedInPage", ()=>$9ce9420d6adb67d7$export$a7ca0608784708a1);
    $parcel$export(module.exports, "getTrialDaysLeft", ()=>$9ce9420d6adb67d7$export$954628993bf3188e);
    $parcel$export(module.exports, "isInGracePeriod", ()=>$9ce9420d6adb67d7$export$271517afaa0c15eb);
    var $kTK0a;
    var $2vSU6;
    var $cYlk7;
    var $9OXo1;
    function $9ce9420d6adb67d7$export$f8e1c288fefa6e7d() {
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        return jswEntitlement?.billingSourceSystem === 'CCP';
    }
    function $9ce9420d6adb67d7$export$b367e04990bbb76d(projectType) {
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const productKey = (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const productEntitlement = productEntitlementDetails?.[productKey];
        return productEntitlement?.billingSourceSystem === 'CCP';
    }
    function $9ce9420d6adb67d7$export$a7ca0608784708a1({ pageUrl: pageUrl }) {
        const { data: currentUserData } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const encodedPageUrl = encodeURIComponent(pageUrl);
        const encodedUserEmail = encodeURIComponent(currentUserData.user.emailAddress ?? '');
        return `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
    }
    const $9ce9420d6adb67d7$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
    const $9ce9420d6adb67d7$export$954628993bf3188e = (currentDate, trialEndTime)=>trialEndTime ? Math.ceil(($9ce9420d6adb67d7$export$9dbbf537dffaafc7(trialEndTime) - currentDate) / 86400000) : undefined;
    const $9ce9420d6adb67d7$export$271517afaa0c15eb = (currentDate, trialEndTime)=>{
        const trialDaysLeft = $9ce9420d6adb67d7$export$954628993bf3188e(currentDate, trialEndTime);
        return !trialDaysLeft || trialDaysLeft < 0;
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("5oBMG", function(module, exports) {
    $parcel$export(module.exports, "useProductEntitlementDetails", ()=>$3295ae4955475ae4$export$e02d6385b5d47f5d);
    var $9OXo1;
    const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.productEntitlementDetails || null;
    };
});
parcelRegister("8y2Jg", function(module, exports) {
    $parcel$export(module.exports, "recommendPremiumToStandardModalEntryPoint", ()=>$6c0a47fc92e7dcd3$export$cfb9acf6e9b90816);
    var $cUBPq;
    var $eufEc;
    var $fEDBv;
    const $6c0a47fc92e7dcd3$export$cfb9acf6e9b90816 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(async ()=>(parcelRequire("faS41")).then(({ RecommendPremiumToStandardModalRenderer: RecommendPremiumToStandardModalRenderer })=>RecommendPremiumToStandardModalRenderer), {
            moduleId: "ca434ceb"
        }),
        getPreloadProps: ({ cloudIds: cloudIds })=>({
                queries: {
                    getRecommendPremiumToStandardUrlQuery: {
                        parameters: (0, (0, parcelRequire("cUBPq")).default),
                        variables: {
                            cloudIds: cloudIds
                        }
                    }
                }
            })
    });
});
parcelRegister("cUBPq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61fc4f0c418305bc$export$2e2bcd8739ae039);
    const $61fc4f0c418305bc$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "aa260c993e91f7d86533d0a8cea0615a765e703917b12c3cc91b94536461e7e9",
            "metadata": {},
            "name": "uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $61fc4f0c418305bc$export$2e2bcd8739ae039 = $61fc4f0c418305bc$var$node;
});
parcelRegister("faS41", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("ipxYW")
    ]).then(()=>parcelRequire('9HVXx'));
});
parcelRegister("2LVEz", function(module, exports) {
    $parcel$export(module.exports, "isProjectTypeAndEditionSupported", ()=>$e648e60ba2ea6512$export$c9a5a2a3868318aa);
    var $2vSU6;
    var $ldyPw;
    const $e648e60ba2ea6512$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project);
        if (!projectType || projectType !== (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)) return false;
        return applicationEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
    };
});
